import domify from "domify";
import uid from "uid";
import viewloader from "viewloader";
import bus from "../bus";
import toggleClass from "../toggle-class";
import { FLASH } from "../action-types";

const views = {
  toggleClass
};

/**
 * Viewloader compatible class to allow server rendered and JS activated
 * flash messages coexist.
 * @param  {Element} el
 */
export default function flash(el) {
  const contextEl = el.querySelector(".flash-container") || el;
  bus.on(FLASH, options => {
    window.requestAnimationFrame(() => {
      const flashEl = buildElement(
        options.message,
        options.type,
        options.autoDismiss
      );
      contextEl.appendChild(flashEl);

      window.requestAnimationFrame(() => {
        const viewManager = viewloader(views, flashEl);
        viewManager.callViews();
      });

      if (options.target) {
        const scrollToTarget = document.querySelector(options.target);
        scrollToTarget.scrollIntoView({
          behavior: "smooth"
        });
      }
    });
  });
}

/**
 * Build the flash element
 * @param  {String} message Message to include
 * @param  {String} type    notice/system
 * @return {Element} Domified element
 */
function buildElement(message, type = "notice", autoDismiss = true) {
  const targetClassName = `flash--${uid()}`;
  const toggleClassProps = {
    event: "click",
    targetSelector: `.${targetClassName}`,
    targetLoadClassName: "flash--hidden",
    targetToggleClassName: "flash--hidden"
  };
  if (autoDismiss !== false) {
    toggleClassProps["triggerAfter"] = 8000;
  }
  return domify(`
    <div class='flash flash--${type} t-alternate ${targetClassName} flash--hidden'>
      <div class='flash__message clearfix'>
        <p class='fl-left'>${message}</p>
        <button class='flash__dismiss fl-right' data-view-toggle-class='${JSON.stringify(
          toggleClassProps
        )}'>
          <span class='hide-all'>Dismiss</span><span class='flash__x'>×</span>
        </button>
      </div>
    </div>
  `);
}
